<template>
  <div @click="onClick">
    <svg-icon :icon-name="isFullscreen ? 'screen-out' : 'screen-in'" :icon-class="iconClass" />
    <slot></slot>
  </div>
</template>

<script>
import screenfull from 'screenfull'

export default {
  name: 'JhScreenfull',

  props: {
    iconClass: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      isFullscreen: false
    }
  },

  mounted () {
    this.init()
  },

  beforeDestroy () {
    this.destroy()
  },

  methods: {
    onClick () {
      if (!screenfull.isEnabled) {
        this.$message({ message: '您的浏览器不支持全屏', type: 'warning' })
        return false
      }
      screenfull.toggle()
    },

    change () {
      this.isFullscreen = screenfull.isFullscreen
    },

    init () {
      if (screenfull.isEnabled) {
        screenfull.on('change', this.change)
      }
    },

    destroy () {
      if (screenfull.isEnabled) {
        screenfull.off('change', this.change)
      }
    }
  }
}
</script>
